export default __webpack_public_path__ + "static/media/codeblack_phone.7f4626ba.png";